import { HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EduContentProductTypeApi } from '../+api';
import { EduContentProductTypeInterface } from '../+models';
import { EduContentProductTypeServiceInterface } from './edu-content-product-type.service.interface';

@Injectable({
  providedIn: 'root',
})
export class EduContentProductTypeService implements EduContentProductTypeServiceInterface {
  private eduContentProductTypeApi = inject(EduContentProductTypeApi);

  getAll(): Observable<EduContentProductTypeInterface[]> {
    return this.eduContentProductTypeApi.find();
  }

  getEduContentProductTypes$(
    searchTerm?: string,
    filters?: { [key: string]: string | number[] | number },
    pagination?: { from?: any; amount?: any },
    columns?: string[],
    sorting?: { [key: string]: 'asc' | 'desc' }
  ): Observable<{ results: EduContentProductTypeInterface[]; count: number }> {
    const params = new HttpParams({
      fromObject: {
        searchTerm: searchTerm || '',
        filters: JSON.stringify(filters || {}),
        columns: JSON.stringify(columns || null),
        sorting: JSON.stringify(sorting || {}),
        pagination: JSON.stringify(pagination || {}),
      },
    });
    return this.eduContentProductTypeApi.getEduContentProductTypes(params);
  }

  createEduContentProductType(
    eduContentProductType: EduContentProductTypeInterface
  ): Observable<EduContentProductTypeInterface> {
    return this.eduContentProductTypeApi.createEduContentProductType(eduContentProductType);
  }

  updateEduContentProductType(
    eduContentProductType: EduContentProductTypeInterface
  ): Observable<EduContentProductTypeInterface> {
    const params = new HttpParams({
      fromObject: {
        id: eduContentProductType.id?.toString(),
      },
    });
    return this.eduContentProductTypeApi.updateEduContentProductType(params, eduContentProductType);
  }

  deleteEduContentProductType(eduContentProductType: EduContentProductTypeInterface): Observable<boolean> {
    return this.eduContentProductTypeApi.deleteById(eduContentProductType.id);
  }
}
